(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: window.ssPdpCurrency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP',
    }).format(cents / 100);
  }

  function savePercentHtml(compare, price) {
    if (compare <= price) return '';
    var pct = Math.round(((compare - price) / compare) * 100);
    return '<span class="ss-pdp-top__price-save">Save ' + pct + '%</span>';
  }

  function priceRowHtml(price, compare) {
    if (compare > price) {
      return (
        '<span class="ss-pdp-top__price-compare">' +
        formatMoney(compare) +
        '</span><span class="ss-pdp-top__price-sale">' +
        formatMoney(price) +
        '</span>' +
        savePercentHtml(compare, price)
      );
    }
    return '<span class="ss-pdp-top__price-current">' + formatMoney(price) + '</span>';
  }

  function getCartSectionId() {
    var cartItems = document.querySelector('cart-items-component[data-drawer]');
    return cartItems ? cartItems.dataset.sectionId : '';
  }

  function dispatchCartUpdate(cart, form, sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: form.id,
          data: {
            source: 'ss-pdp-form',
            itemCount: cart.item_count,
            sections: sections || {},
          },
        },
      })
    );

    if (window.ssCart && typeof window.ssCart.updateCount === 'function') {
      window.ssCart.updateCount(cart.item_count);
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component[data-ss-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    if (window.ssCart && typeof window.ssCart.open === 'function') {
      window.ssCart.open();
      return true;
    }
    return false;
  }

  function ajaxAddToCart(form, atcBtn) {
    if (atcBtn) atcBtn.disabled = true;

    var formData = new FormData(form);
    var sectionId = getCartSectionId();
    if (sectionId) {
      formData.append('sections', sectionId);
    }

    return fetch(window.Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          var message = response.description || response.message || 'Could not add to cart.';
          window.alert(message);
          return;
        }

        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            dispatchCartUpdate(cart, form, response.sections);
            openCartDrawer();
          });
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (atcBtn && atcBtn.dataset.ssSoldOut !== 'true') {
          atcBtn.disabled = false;
        }
      });
  }

  function initStickyBar(sectionRoot, form, atcBtn) {
    var stickyBar = sectionRoot.querySelector('[data-ss-pdp-sticky]');
    var stickyAtc = sectionRoot.querySelector('[data-ss-pdp-sticky-atc]');
    var buyTarget = sectionRoot.querySelector('[data-ss-pdp-buy-buttons]') || atcBtn;
    var observeTarget = atcBtn || buyTarget;
    if (!stickyBar || !stickyAtc || !observeTarget || !form) return;

    if (stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }

    var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    var isStuck = false;
    var hiddenByFooter = false;
    var scrollTicking = false;

    function setStickyVisible(visible) {
      isStuck = visible;
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBar.classList.toggle('is-visible', visible);
      document.documentElement.classList.toggle('ss-pdp-sticky-active', visible);
    }

    function evaluateSticky() {
      var rect = observeTarget.getBoundingClientRect();
      var scrolledPast = rect.bottom <= 8;

      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight) {
          hiddenByFooter = true;
          if (isStuck) setStickyVisible(false);
          return;
        }
      }

      hiddenByFooter = false;

      if (scrolledPast) {
        setStickyVisible(true);
      } else if (rect.top < window.innerHeight && rect.bottom > 0) {
        setStickyVisible(false);
      }
    }

    function scheduleEvaluate() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        evaluateSticky();
        scrollTicking = false;
      });
    }

    var buyObserver = new IntersectionObserver(
      function () {
        scheduleEvaluate();
      },
      { threshold: [0, 0.01, 0.1, 1], rootMargin: '0px 0px 0px 0px' }
    );

    buyObserver.observe(observeTarget);

    if (footer) {
      var footerObserver = new IntersectionObserver(
        function () {
          scheduleEvaluate();
        },
        { rootMargin: '0px 0px 0px 0px', threshold: 0 }
      );
      footerObserver.observe(footer);
    }

    window.addEventListener('scroll', scheduleEvaluate, { passive: true });
    window.addEventListener('resize', scheduleEvaluate, { passive: true });
    window.addEventListener('orientationchange', scheduleEvaluate, { passive: true });
    document.addEventListener('visibilitychange', scheduleEvaluate, { passive: true });

    scheduleEvaluate();

    stickyAtc.addEventListener('click', function () {
      if (!atcBtn || atcBtn.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(atcBtn);
      } else {
        atcBtn.click();
      }
    });
  }

  document.querySelectorAll('[data-ss-pdp-form]').forEach(function (form) {
    var sectionRoot = form.closest('.ss-pdp-top-section');
    if (!sectionRoot) return;

    var variantInput = form.querySelector('[data-ss-pdp-variant-input]');
    var variantSelect = form.querySelector('[data-ss-pdp-variant-select]');
    var priceEl = sectionRoot.querySelector('[data-ss-pdp-price]');
    var atcBtn = form.querySelector('[data-ss-pdp-atc]');
    var options = form.querySelectorAll('[data-ss-pdp-variant-option]');
    var qtyInput = form.querySelector('[data-ss-pdp-qty-input]');
    var stickyPrice = sectionRoot.querySelector('[data-ss-pdp-sticky-price]');
    var stickyAtc = sectionRoot.querySelector('[data-ss-pdp-sticky-atc]');

    function atcLabel(available) {
      if (!available) return atcBtn.dataset.soldOutLabel || 'Sold out';
      return atcBtn.dataset.defaultLabel || atcBtn.textContent.trim();
    }

    function getVariantNode(variantId) {
      if (variantSelect) {
        return variantSelect.querySelector('option[value="' + variantId + '"]');
      }
      return Array.prototype.find.call(options, function (btn) {
        return String(btn.dataset.variantId) === String(variantId);
      });
    }

    function setVariant(variantId) {
      if (variantSelect) {
        variantSelect.value = variantId;
      } else {
        options.forEach(function (btn) {
          var selected = String(btn.dataset.variantId) === String(variantId);
          btn.classList.toggle('is-selected', selected);
        });
        if (variantInput) variantInput.value = variantId;
      }

      var active = getVariantNode(variantId);
      if (!active) return;

      var price = parseInt(active.dataset.variantPrice, 10);
      var compare = parseInt(active.dataset.variantCompare, 10);
      var available = active.dataset.variantAvailable === 'true';
      var priceHtml = priceRowHtml(price, compare);

      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPrice) stickyPrice.innerHTML = priceHtml;

      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.dataset.ssSoldOut = available ? 'false' : 'true';
        atcBtn.textContent = atcLabel(available);
      }

      if (stickyAtc) {
        stickyAtc.disabled = !available;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    if (atcBtn && !atcBtn.dataset.defaultLabel) {
      atcBtn.dataset.defaultLabel = atcBtn.textContent.trim();
      atcBtn.dataset.soldOutLabel = atcBtn.dataset.soldOutLabel || 'Sold out';
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        setVariant(variantSelect.value);
      });
    } else {
      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          setVariant(btn.dataset.variantId);
        });
      });
    }

    form.querySelectorAll('[data-ss-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = btn.dataset.ssPdpQty === 'plus' ? value + 1 : Math.max(1, value - 1);
      });
    });

    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name !== 'add') return;
      if (!window.Theme || !window.Theme.routes || !window.Theme.routes.cart_add_url) return;

      event.preventDefault();
      ajaxAddToCart(form, atcBtn);
    });

    initStickyBar(sectionRoot, form, atcBtn);

    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('variant');
    if (urlVariant) setVariant(urlVariant);
  });
})();
